import { axiosAuthenticatedRawPost } from "./index";
import { remBgImageMimeTypesDropzone } from "../utility/Enum";

export const REM_BG_IMAGE_MAX_SIZE = 5 * 1024 * 1024;

export const getRemBgImageContentType = (file) =>
  Object.prototype.hasOwnProperty.call(remBgImageMimeTypesDropzone, file?.type)
    ? file.type
    : "application/octet-stream";

export const uploadRemBgImage = ({
  uploadType,
  itemId,
  file,
  rawPost = axiosAuthenticatedRawPost,
}) =>
  rawPost(
    `/uploadRemBg?uploadType=${encodeURIComponent(
      uploadType
    )}&itemId=${encodeURIComponent(itemId)}`,
    file,
    getRemBgImageContentType(file)
  );
